import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';
import { TranscriptImportDialogState } from '../transcript-import-dialog.state';

import { SelectUser } from './select-user.action';

export function selectUserReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, SelectUser>,
): TranscriptImportDialogState {
    return {
        ...state,
        selectedUserId: action.payload.userId,
        selectedUserName: action.payload.name,
    };
}
